export const REDUCER_KEY = 'adTypeExtraFees';
